import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import closeIcon from '../static/img/SelectGame/iconCloseButton.svg';
import styles from '../static/styles/DailyCheckin.module.css';
import RewardClaimPopup from '../components/RewardClaimPopup';
import WelcomeImage from '../static/img/DailyCheckin/imageWelcome.avif';
import WelcomeBackImage from '../static/img/DailyCheckin/imageWelcomeBack.avif';
import { claimDailyReward, getActiveDayData, updateActiveDayData } from '../api/auth';

import tickIcon from '../static/img/DailyCheckin/iconTick.svg';
import lockIcon from '../static/img/DailyCheckin/iconLock.svg';

import taskHeaderIcon from '../static/img/DailyCheckin/iconTaskHeader.svg';

import dayClaimedIcon from '../static/img/DailyCheckin/iconDayClaimed.svg';
import dayCurrentIcon from '../static/img/DailyCheckin/iconDayCurrent.svg';
import DayItem from '../components/DayItem';

const DailyCheckin = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [activeDay, setActiveDay] = useState(null);
  const [rewardClaimed, setRewardClaimed] = useState(false);
  const [showRewardPopup, setShowRewardPopup] = useState(false);
  const activeDayData = JSON.parse(localStorage.getItem('activeDayData'));

  useEffect(() => {
    // const storedActiveDay = localStorage.getItem('activeDay');
    // const storedRewardClaimed = localStorage.getItem('rewardClaimed');

    // if (storedActiveDay) {
    //   setActiveDay(JSON.parse(storedActiveDay));
    //   console.log('Active day:', JSON.parse(storedActiveDay));
    // }

    // if (storedRewardClaimed) {
    //   setRewardClaimed(JSON.parse(storedRewardClaimed));
    // }
  }, []);


  useEffect(() => {
    // const storedActiveDay = localStorage.getItem('activeDay');
    // const storedRewardClaimed = localStorage.getItem('rewardClaimed');

    // if (storedActiveDay) {
    //   setActiveDay(JSON.parse(storedActiveDay));
    //   console.log('Active day:', JSON.parse(storedActiveDay));
    // }

    // if (storedRewardClaimed) {
    //   setRewardClaimed(JSON.parse(storedRewardClaimed));
    // }
  }, [isOpen]);

  const daysPerPage = 8;
  const pagesToShow = 3;

  // Calculate current set index based on activeDay from localStorage..
  const currentSetIndex = activeDay ? Math.floor((activeDay - 1) / daysPerPage) : 0;
  const startSetIndex = Math.max(0, currentSetIndex - 1); // avoid -ve nmbr

  const visibleStartDays = Array.from({ length: pagesToShow }, (_, i) =>
    (startSetIndex + i) * daysPerPage + 1
  );

  const handleClaimReward = async () => {
    try {
      if (activeDayData) {
        const response = await updateActiveDayData();
        if (response.success) {
          setShowRewardPopup(true);


        } else {
          setRewardClaimed(true);
          localStorage.setItem('rewardClaimed', 'true');
        }
        const activeDayData = await getActiveDayData();
        if (activeDayData) {
          localStorage.setItem("activeDayData", JSON.stringify(activeDayData));
          localStorage.setItem('activeDay', activeDayData.active_streak);
          localStorage.setItem('gameId', activeDayData.gameId);
        }
      }
    } catch (error) {
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleCloseRewardPopup = () => {
    setShowRewardPopup(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.dailyCheckinContainer}>
      <div className={styles.dailyCheckinOverlay}>
        <img
          src={closeIcon}
          alt="Close"
          className={styles.closeButton}
          onClick={handleClose}
        />

        <div className={styles.rewardsHeader}>
          {/* <h2 className={styles.checkinTitle}>REWARDS</h2> */}
          <img src={activeDayData?.active_streak > 0 ? WelcomeBackImage : WelcomeImage} alt={t('welcome')} className={styles.welcomeImage} />
          <p className={styles.welcomeMsg}>{t('keep_back_f_creds')}</p>
        </div>

        <div style={{ display: 'flex', width: '100%', marginTop: '4em', gap: '10px' }}>
          <div style={{ width: '25%', alignSelf: 'flex-end' }}>
            {(activeDayData.streak_to_claim - 1) > 0 && <DayItem day={activeDayData.streak_to_claim - 1} activeDay={activeDayData.streak_to_claim} rewardAmount={activeDayData.amount_to_claim - 5} />}
          </div>
          <div style={{ width: '50%' }}>
            <DayItem day={activeDayData.streak_to_claim} activeDay={activeDayData.streak_to_claim} rewardAmount={activeDayData.amount_to_claim} />
          </div>
          <div style={{ width: '25%', alignSelf: 'flex-end' }}>
            <DayItem day={activeDayData.streak_to_claim + 1} activeDay={activeDayData.streak_to_claim} rewardAmount={activeDayData.amount_to_claim + 5} />
          </div>
        </div>
        <div className={styles.claimBtnHeader} onClick={handleClaimReward}>
          <button className={styles.claimBtn} disabled={activeDayData.rewardClaimed} >{activeDayData.rewardClaimed ? t('already_claimed') : t('claim')} </button>
        </div>
      </div>


      {showRewardPopup && <RewardClaimPopup
        isOpen={showRewardPopup}
        onClose={handleCloseRewardPopup}
        credits={activeDayData.amount_to_claim}
      />}

    </div>
  );
};

export default DailyCheckin;